<template>
  <v-menu offset-y top :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch edit</v-btn>
    </template>
    <v-card flat width="350">
      <v-card-title>Batch edit</v-card-title>
      <v-card-subtitle>Only checked fields will be updated</v-card-subtitle>
      <v-card-text class="pa-0">
        <v-container class="pt-0 px-6">
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="input.updateActive"/>
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Active" v-model="input.active" hide-detlails :disabled="!input.updateActive"/>
            </v-col>
          </v-row>
          <v-row v-if="connectedToAccounting && values">
            <v-col cols="2">
              <v-simple-checkbox v-model="input.updateAccount" class="mt-2"/>
            </v-col>
            <v-col>
              <account-picker v-model="input.inventoryAccountRef" label="Inventory asset account"
                              :disabled="!input.updateAccount"
                              :accounts="accounts" :addTypes="['OtherCurrentAsset']" hint=""/>
            </v-col>
          </v-row>
        </v-container>
        <v-divider/>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="open=false">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>

export default {
  name: 'EquipmentTanksBatchEdit',
  props: {
    tanks: {type:Array, required:true}
  },
  data() {
    return {
      open: false,
      input: {updateActive: false, updateAccount: false,
              active:true, inventoryAccountRef:'',
              tanks:[]},
      accounts: [],
      saving: false
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    }
  },
  async created() {
    if (!this.connectedToAccounting)
      return;

    const results = await this.$apiCall(`query EquipmentTanksBatchEdit($currency: String!) {
                                            companyAccounts {tankInventory}
                                            accounts(currency:$currency) {
                                              ref,name,type
                                            }
                                          }`,
                                        {currency:this.$store.getters.company.settings.homeCurrency});
    if (!results.error) {
      this.accounts = results.data.accounts.filter(account => account.type === 'OtherCurrentAsset');
      this.input.inventoryAccountRef = results.data.companyAccounts.tankInventory;
    }
  },
  methods: {
    async save() {
      this.saving = true;
      this.input.tanks = this.tanks.map(tank => tank.id);
      const results = await this.$apiCall(`mutation EquipmentTanksBatchEdit($input: TankBatchUpdateInput!) {
                                              tanksBatchUpdate(input:$input) {id,error}
                                            }`,
                                          {input:this.input});
      this.saving = false;
      if (!results.error) {
        this.open = false;
        const errorCount = results.data.tanksBatchUpdate.length;
        this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                        message:`Updated ${this.tanks.length - errorCount} of ${this.tanks.length} tanks\
                                                  ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
        this.$emit('refresh', results.data.tanksBatchUpdate);
      }
    }
  }
}
</script>